<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">

        <!-- Add notice form -->
        <div class="card p-4 lg:p-6">
            <h6 class="card-title">Add Lead</h6>
            <form>
                <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">
                    <div class="col-span-full  lg:col-span-4 leading-none">
                        <label for="" class="form-label">Name *</label>
                        <input type="text"  v-model="lead.name" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Contact *</label>
                        <input type="number"  v-model="lead.contact" placeholder="Type Here"
                            class="form-input" required autocomplete="off" @input="checkIfExist">
                    </div>
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Address *</label>
                        <input type="text" v-model="lead.address" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>



                    <div class="col-span-full  lg:col-span-4 leading-none">
                        <label class="form-label">Gender *</label>
                        <select class="form-input" v-model="lead.gender">
                            <option DISABLED value="0">SELECT GENDER</option>

                            <option value="male">Male</option>
                            <option value="female">Female</option>

                            <!-- <option v-for="(item, index)  in catList" :value="item.id">{{ item.name }}</option> -->
                        </select>
                    </div>




                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Age *</label>
                        <input type="number" v-model="lead.age" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Next Date *</label>
                        <input type="date" v-model="lead.nextdate" placeholder="Type Here" class="form-input" required
                            autocomplete="off"   :min="today">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Remark *</label>
                        <input type="text" v-model="lead.remark" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>

                </div>
            </form>
            <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6">
                Add Lead
            </button>

        </div>
<!-- 
        <div v-if="leadExists">
            <h2>Lead List</h2>
            <ul>
              <li v-for="(lead, index) in leads" :key="index">
                {{ lead.contact }}
              </li>
            </ul>
          </div>
      
          <div v-else-if="contactChecked">
            <p>No lead found with this contact number.</p>
          </div> -->

<div class="p-6 space-y-4"  v-if="isFound">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Name</th>
                                    <th class="bg-[#B2E8D9]">Contact No</th>
                                    <!-- <th class="bg-[#B2E8D9]">Cost</th> -->
                                    
                                    <th class="bg-[#B2E8D9]">Address</th>
                                    <th class="bg-[#B2E8D9]">Gender</th>
                                    <th class="bg-[#B2E8D9]">Remark</th>
                                    <th class="bg-[#B2E8D9]">NextDate</th>
                                    <th class="bg-[#B2E8D9]">Action</th>
                                    
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in followup_list" :key="item.id">
                                    <td>{{item.name}}</td>
                                    <td>{{item.contact}}</td>
                                    <td>{{item.address}}</td>
                                    <td>{{item.gender}}</td>
                                    <td>{{item.remark}}</td>
                                    <td>{{item.nextdate}}</td>
                                    <td class="px-3.5 py-4">
                                        <div class="flex items-center gap-1">
                                            <button class="btn-icon btn-primary-icon-light size-7"  @click="editModal(item)"  >
                                                <i class="ri-add-line text-danger text-[13px]"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr> 
                            </tbody>
                        </table>
                    </div> 
                    
                    
      
          


    </div>



</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
    name: 'AddProduct',
    components: {

    },
    mounted() {
        this.getBasics();
        // $(".form-input").on('keyup')
    },
    data() {
        return {
            isAdd: 0,
            isEdit: 0,
            isDelete: 0,
            deleteId: 0,
            isFound:false,
            catList: [],
            followup_list:[],
            lead: { 
                name: '', 
                contact:'',
                address:'',
                gender:'',
                age:'',
                nextdate:'',
                remark:'',
            
            },
            leads: [],
      leadExists: false,
      contactChecked: false
            // employees: { empname: '', emprole: '0', isMainAdmin: 0 },
        }
    },
    methods: {
        
        
            async checkIfExist() {
            var self = this;     
                if(self.lead.contact.toString().length == 10){
                   axios.post('getIsContactExist',{cell:self.lead.contact}).then(function (response) {
                       if(response.data.is==1)
                        self.isFound=true;
                            self.catList = response.data.cats;
                            self.employees = response.data.userDetails;
                            self.followup_list = response.data.followup_list;
                        });
            
                        
                    }
        },
        nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },
        
        
        
        checkContact() {
      this.leadExists = false;
      this.contactChecked = false;

    //   if (this.lead.contact.length > 0) {
        // alert("in");
        axios.post('/lead/checkContact', { contact: this.lead.contact })
          .then(response => {
            if (response.data.exists) {
              this.leads = response.data.lead; 
              console.log(this.leads);
              this.leadExists = true;
            } else {
              this.contactChecked = true;
            }
          })
          .catch(error => {
            console.error('Error checking contact number:', error);
          });
    //   }
    },
        today()
        {
        const dateObj = new Date();
        var day=dateObj.getDate();
        var month=dateObj.getMonth()+1;
        
        const currentDate = ((day<10)?'0'+day:day)+"/"+((month<10)?'0'+month:month)+"/"+dateObj.getFullYear();
        return currentDate;
        },
        async getBasics() {
            var self = this;
            axios.post('getProdCats').then(function (response) {
                self.catList = response.data.cats;
                self.employees = response.data.userDetails;
            });

            const date = new Date();
            this.today = date.toISOString().split('T')[0];  // Format: YYYY-MM-DD
            this.maxDate = this.today;  // Set max date to today
            //this.lead.nextdate = this.today; 
        },
        nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },

        
        save() {
             var self = this;
           // alert(JSON.stringify(self.lead));
             if (self.lead.name == '') 
                self.$swal("lead Name is Required");
            // else if (self.product.salerate == '') 
            //     self.$swal("Salerate is Required"); 
            else {
                self.$swal({
                    title: "Do You Want To Save?",
                    text: "Are you sure? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('addlead', this.lead)
                            .then(response => {
                                var msg = response.data.msg;
                                var isSuccess = response.data.status;
                                // self.catList = response.data.cats;
                                // self.employees = response.data.userDetails;
                                // self.cat = { name: '', status: 'Active' };
                                if (isSuccess == 1) {
                                    self.lead = { name: '', contact: '', address: '', gender: '', age: '', nextdate: '',remark: ''};
                                   // $("#barcode").focus();
                                }


                                self.$swal(msg);

                            })
                            .catch(error => {
                                console.log('Error on Authentication: ' + error);
                            });
                    }
                });
            }

        }












    }
}
</script>
